import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    color: 'alpha.800',
    minW: '190px',
    mr: '3',
    height: 'fit-content',
    boxShadow: 'md',
    borderRadius: 'md',
    overflow: 'hidden',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
  },
  accordionButton: {
    pl: '3',
    pr: '2',
    bgGradient: 'linear(to-b, alpha.500, gamma.500)',

    borderBottomWidth: '1px',
    borderBottomColor: 'alpha.800',
    borderTopWidth: '1px',
    borderTopColor: 'alpha.400',
    _hover: { bgGradient: 'linear(to-b, alpha.500, alpha.600)' },
  },
  accordionHeadingText: {
    flex: '1',
    fontSize: 'sm',
    textAlign: 'left',
    fontWeight: 'bold',
  },
  accordionIcon: {
    color: 'alpha.500',
  },
  accordionPanel: {
    p: '0',
    fontSize: 'xs',
    bg: 'alpha.400',
    color: 'alpha.800',
    fontWeight: 'medium',

    _last: {
      border: 'none',
    },
  },
};
